const GuidesPaper: React.FC = () => {
  return (
    <div className="featured-articles-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132;{" "}
        <a href="/guides" className="breadcrumb-link">
          Guides
        </a>{" "}
        &#10132; Paper trades guide
      </p>
      <h2 className="help-heading">Paper trades guide</h2>
      <p style={{ fontStyle: "italic", fontWeight: "bold" }}>
        How do I make a Paper Buy?
      </p>
      <p className="featured-article-text">
        Making a paper trade is simple. Wherever you see a public message box at
        the bottom of your screen, you can type in a paper trade. This includes
        message boxes on user’s profiles, in company channels or in article
        comments. If you make a paper trade in a private message or private
        channel, it will not be registered as in the paper trades channel or on
        your profile.
      </p>
      <p className="featured-article-text">
        To buy a security using paper trades, simply type: buy:ticker symbol.
        You do not need to add a space or a $ sign, and the entry is not case
        sensitive. For example, to buy a share of GoldSpot, simply type
        buy:spot.
      </p>
      <img
        src={require("../../../assets/paper-article-1.png")}
        alt="paper-article-1"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        The following pop-up will appear – simply click ok, and the trade is
        posted.
      </p>
      <img
        src={require("../../../assets/paper-article-2.png")}
        alt="paper-article-2"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        If the trade has been posted, it will appear with a green highlight.
      </p>
      <img
        src={require("../../../assets/paper-article-3.png")}
        alt="paper-article-3"
        className="basic-article-1"
      />
      <p style={{ fontStyle: "italic", textAlign: "center" }}>
        The trade will not be posted correctly if there is a space or $ symbol
      </p>
      <p className="featured-article-text">
        After you make a paper buy, the trade will appear in the paper trades
        channel and on your profile with a % change icon. This % change will
        update continuously until you sell, after which the final percentage
        change will be posted next to the sale.
      </p>
      <p style={{ fontStyle: "italic", fontWeight: "bold" }}>
        How do I make a Paper Sale?
      </p>
      <p className="featured-article-text">
        To enter a paper sale of a company, simply type sell:ticker symbol.
      </p>
      <img
        src={require("../../../assets/paper-article-4.png")}
        alt="paper-article-4"
        className="basic-article-1"
      />
      <p style={{ fontStyle: "italic", fontWeight: "bold" }}>
        How do I make a Paper Short?
      </p>
      <p className="featured-article-text">
        If you make a paper sale of a security without already owning it, the
        sale will appear on your profile as a short. To close the position, make
        a paper buy of the security. Once a short position is closed, it will
        appear on your profile as a covered short, with a final percentage
        gain/loss.
      </p>
      <img
        src={require("../../../assets/paper-article-5.png")}
        alt="paper-article-5"
        className="basic-article-1"
      />
      <p style={{ fontStyle: "italic", fontWeight: "bold" }}>
        Can I Buy Twice?
      </p>
      <p className="featured-article-text">
        It is also possible to buy more or short more of a security without
        losing your initial position. When you close out the position, the
        average % gain/loss across all trades of that security will be
        displayed.
      </p>
      <img
        src={require("../../../assets/paper-article-6.png")}
        alt="paper-article-6"
        className="basic-article-1"
      />
      <p style={{ fontStyle: "italic", fontWeight: "bold" }}>
        Can I Delete a Paper Trade?
      </p>
      <p className="featured-article-text">
        It is possible to delete a paper trade message – this will remove it
        from the original posting location and from the paper trades channel.
        However, the trade and associated gains or losses will permanently
        remain on your profile.{" "}
      </p>
      <p className="featured-article-text">
        To delete a paper trade, click on the non-highlighted part of the
        message box to expand the message, and then click delete. Note - this
        will only work within the 15-minute posting window. If you wait longer
        than 15 minutes, then it will not be possible to delete the post.
        Clicking the highlight will bring you to the relevant company’s page.
      </p>
      <img
        src={require("../../../assets/paper-article-7.png")}
        alt="paper-article-7"
        className="basic-article-1"
      />
    </div>
  );
};

export default GuidesPaper;
